import { createSlice } from '@reduxjs/toolkit';

const notificationSlice = createSlice({
  name: 'notifications',
  initialState: {
    notifications: [],
    unreadCount: 0,
    isLoading: false,
  },
  reducers: {
    setNotifications: (state, action) => { state.notifications = action.payload; },
    addNotification: (state, action) => {
      state.notifications.unshift(action.payload);
      state.unreadCount += 1;
    },
    setUnreadCount: (state, action) => { state.unreadCount = action.payload; },
    markAsRead: (state, action) => {
      const ids = action.payload;
      state.notifications = state.notifications.map(n =>
        ids.includes(n._id) ? { ...n, isRead: true } : n
      );
      state.unreadCount = state.notifications.filter(n => !n.isRead).length;
    },
    markAllAsRead: (state) => {
      state.notifications = state.notifications.map(n => ({ ...n, isRead: true }));
      state.unreadCount = 0;
    },
    setLoading: (state, action) => { state.isLoading = action.payload; },
  },
});

export const { setNotifications, addNotification, setUnreadCount, markAsRead, markAllAsRead, setLoading } = notificationSlice.actions;
export default notificationSlice.reducer;
